import React, { useEffect, useMemo, useRef, useState } from 'react';
import './index.css';
import {
  BellOutlined,
  CloudDownloadOutlined,
  CustomerServiceOutlined,
  DownOutlined,
  FileDoneOutlined,
  QuestionCircleOutlined,
  ScheduleOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import {
  Badge,
  Divider,
  Drawer,
  Dropdown,
  Input,
  Layout,
  MenuProps,
  message,
  Modal,
  notification,
  Popover,
  Space,
  Tabs,
  theme,
} from 'antd';
import type { DrawerProps, TabsProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSnapshot } from 'valtio';
import languageImg from '@/assets/images/RoyalcaninDataBoard/language.png';
import { enterShopApi } from '@/api/shop/shop';
import busEvent from '@/utils/bus';
import { getUpdateMessageApi, getUserMessageApi } from '../../../api/userIntersection/userIntersection';
import {
  setCurrentShopId,
  setCurrentShopIsPop,
  setCurrentShopPlatformType,
  setCurrentShopType,
  setMenu,
  state,
} from '../../../store';
import DownLoadCenter from './component/DownLoadCenter';
import UploadTask from './component/UploadTask';
import UserCenterInfo from './component/UserCenterInfo';

// import { use } from 'echarts'

const { Header } = Layout;

const LZHeader: React.FC = () => {
  // 下载中心
  const location = useLocation();
  // 从 localStorage 读取保存的语言设置，默认为 true (中文)
  const savedLanguage = localStorage.getItem('language');
  const [language, setLanguage] = useState<boolean>(savedLanguage ? JSON.parse(savedLanguage) : true);

  const palteformName: any = localStorage.getItem('plateform') ? localStorage.getItem('plateform') : '';

  const [placement, setPlacement] = useState<DrawerProps['placement']>('right');
  const [downLoadCenterOpen, setDownLoadCenterOpen] = useState<boolean>(false);
  const [uploadTask, setUploadTask] = useState([] as any);
  const onClose = () => {
    setDownLoadCenterOpen(false);
  };
  const [userMessageList, setUserMessageList] = useState<any[]>([]);
  const getUserMessage = async () => {
    const res = await getUserMessageApi();
    console.log(res);
    if (res?.code === 200) {
      setUserMessageList(res.data);
      if (res.data?.length > 0) {
        let tips = res.data.find((item: any) => item.topic === '激活码到期提醒');
        notification.open({
          message: tips.topic,
          description: tips.message,
          duration: 0,
          onClose: () => {
            getUpdateMessage(tips.id);
          },
        });
      }
    }
  };
  const getUpdateMessage = async (id: number) => {
    const res = await getUpdateMessageApi({ messageId: id });
    console.log(res);
    if (res.data) {
      getUserMessage();
    }
  };
  const navigate = useNavigate();
  // const currentLocation = useLocation();
  const settingItem = [
    {
      label: '实施部署',
      key: '1',
    },
    {
      label: '安全配置',
      key: '2',
    },
    {
      label: '隐私脱敏加密',
      key: '3',
    },
    {
      label: '行业模板配置',
      key: '4',
    },
    {
      label: (
        <a
          onClick={() => {
            navigate('/systemSettingManagement/accountAuthority/accountManagement');
          }}>
          账号权限
        </a>
      ),
      key: '5',
    },
  ];
  // 消息盒子
  // const openNotification = (userMessageList:any) => {
  //   userMessageList.forEach((item:any) => {
  //     notification.open({
  //       message: item.topic,
  //       description: item.message,
  //       duration: 0,
  //       onClose:()=>{
  //         getUpdateMessage(item.id)
  //       }
  //     });
  //   });
  // };

  // 任务中心
  // const taskCenterTitle =
  // <div>
  //   任务中心
  // <span style={{fontSize: '12px', color: 'var(--text-font-color4)', marginLeft: '5px'}}>包含上传，下载等任务</span>
  // </div>
  const [tabKey, setTabKey] = useState('1');
  const onChange = (key: string) => {
    // console.log(typeof key, '=============================key');
    setTabKey(key);
  };
  const items: TabsProps['items'] = [
    {
      key: '1',
      label: '下载任务',
      children: (
        <DownLoadCenter
          tabKey={tabKey}
          downLoadCenterOpen={downLoadCenterOpen}
        />
      ),
    },
    {
      key: '2',
      label: '上传任务',
      children: (
        <UploadTask
          tabKey={tabKey}
          downLoadCenterOpen={downLoadCenterOpen}
        />
      ),
    },
  ];
  useEffect(() => {
    // console.log(state.parentMenuId, 'state.parentMenuId=====================================');
    getUserMessage();
  }, []);

  const snap = useSnapshot(state);
  const shopList = snap.shopList || [];
  const currentShopId = snap.currentShopId;

  const shopMenuItems = useMemo<MenuProps['items']>(() => {
    if (!Array.isArray(shopList)) return [];
    return shopList
      .filter(shop => shop && shop.shopId !== undefined && shop.shopId !== null)
      .map(shop => ({
        key: String(shop.shopId),
        label: (
          <div className="lzHeader_shopOption">
            <span className="lzHeader_shopOption-name">{shop.shopName || '--'}</span>
            {shop.platformType ? <span className="lzHeader_shopOption-platform">{shop.platformType}</span> : null}
          </div>
        ),
      }));
  }, [shopList]);
  const resolvedShopMenuItems = shopMenuItems || [];

  const currentShop = useMemo(() => {
    if (!Array.isArray(shopList)) return null;
    return shopList.find(shop => shop?.shopId === currentShopId) || null;
  }, [shopList, currentShopId]);

  const handleShopChange: MenuProps['onClick'] = async info => {
    const targetId = Number(info.key);
    if (!Number.isNaN(targetId)) {
      const targetShop = shopList.find(shop => shop?.shopId === targetId);
      const platformType = targetShop?.platformType ?? null;
      const currentPath = location.pathname;

      try {
        await enterShopApi({
          shopId: targetId,
          autoSelectNextTime: 1,
          nextAutoEnterShopId: targetId,
        });
      } catch (error) {
        console.error(error);
        message.error('保存默认店铺失败，请稍后重试');
      }

      setCurrentShopIsPop(targetShop?.isPop ?? null);
      setCurrentShopPlatformType(platformType);
      setCurrentShopType(targetShop?.shopType ?? null);
      setCurrentShopId(targetId, platformType);

      window.location.reload();
    }
  };

  const { t, i18n } = useTranslation();
  return (
    <Header
      className="lzHeader_container"
      style={{
        boxShadow: !state.parentMenuId ? '' : 'var(--box-shadow1)',
      }}>
      {resolvedShopMenuItems.length > 0 && (
        <Dropdown
          trigger={['click']}
          menu={{ items: resolvedShopMenuItems, onClick: handleShopChange }}>
          <div className="lzHeader_shopSwitch">
            <span className="lzHeader_shopSwitch__text">{currentShop?.shopName || '切换店铺'}</span>
            <DownOutlined className="lzHeader_shopSwitch__icon" />
          </div>
        </Dropdown>
      )}

      {state.jumpLink && state.jumpLink !== '' && (
        <QuestionCircleOutlined
          className="lzHeader_icon"
          style={{ cursor: 'pointer' }}
          onClick={() => window.open(state.jumpLink, '_blank')}
        />
      )}

      <div className="click-element lzHeader_userInfo">
        <UserCenterInfo></UserCenterInfo>
        <DownOutlined
          style={{
            fontSize: 'var(--text-font29)',
            color: 'var(--text-font-color4)',
          }}
        />
      </div>
      <div>
        <Drawer
          title="任务中心"
          placement={placement}
          width={410}
          onClose={onClose}
          open={downLoadCenterOpen}>
          <Tabs
            defaultActiveKey="1"
            items={items}
            onChange={onChange}
          />
        </Drawer>
      </div>
    </Header>
  );
};

export default LZHeader;
